export enum DialogOutcome {
  Undefined,
  Ok,
  Cancel,
}

export type DialogValueType = object | string | boolean | number | null | undefined;